export function repositoryKey(repo) {
  return `${String(repo?.owner || "").toLowerCase()}/${String(repo?.name || "").toLowerCase()}`;
}

export function uniqueRepositories(repos = []) {
  const groups = new Map();
  for (const repo of repos) {
    const key = repositoryKey(repo);
    const id = String(repo?._id || "");
    const existing = groups.get(key);
    if (!existing) {
      groups.set(key, { ...repo, siblingIds: id ? [id] : [] });
      continue;
    }
    if (id && !existing.siblingIds.includes(id)) existing.siblingIds.push(id);
    if (existing.isStarter && !repo.isStarter) {
      existing._id = repo._id;
      existing.isStarter = repo.isStarter;
      existing.status = repo.status;
    }
  }
  return [...groups.values()];
}

export function repositoryIdsFor(repos = [], repositoryId = "") {
  if (!repositoryId) return [];
  const match = repos.find((repo) => String(repo._id) === String(repositoryId) || (repo.siblingIds || []).map(String).includes(String(repositoryId)));
  if (match?.siblingIds?.length) return match.siblingIds.map(String);
  return [String(repositoryId)];
}
